import React, { useEffect, useRef, useState } from 'react';
import { LandingPageStyled } from './landing.page.styled';
import Carousel from 'react-material-ui-carousel';
import i18n from '../../../translations/strings';
import { itemsCarouselLandingPage } from './landing.page.constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLandingContentAction,
  landingAction,
  landingResetState,
} from '../../../store/customers/landing.store';
import HeaderLandingPage from './components/header/header';
import FooterLandingPage from './components/footer/footer';
import TopHero from './components/top-hero/top-hero';
import VideoPlayer from './components/video-player/video-player';
import Description from './components/description/description';
import MapComponent from './components/map-leaflet/map-leaflet';
import { roomsResetState } from '../../../store/customers/rooms-list.store';
import RoomDetail from '../../../components/shared/room-detail/room-detail/room-detail';
import { RoomDetailVariant } from '../../../components/shared/room-detail/room-detail/constants';
import ServiceItem from './components/service-item/service-item';
import LinearLoading from '../../../components/base/loading/linear-loading/linear-loading';
import Button from '../../../components/base/button/button';
import { ButtonVariant } from '../../../components/base/button/constants';
import { servicesLandingPage } from './constants';

const LandingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const servicesRef = useRef(null);
  const roomsRef = useRef(null);
  const [footerRef, setFooterRef] = useState(null);
  const [mapRef, setMapRef] = useState(null);

  const {
    navigationPage,
    loading,
    error,
    errorMeApi,
    allDataFetched,
  } = useSelector((state: any) => {
    return state.landing;
  });

  const {
    loading: loadingRooms,
    roomsList,
    error: errorRooms,
  } = useSelector((state: any) => {
    return state.roomsList;
  });

  const { user } = useSelector((state: any) => {
    return state.user;
  });

  useEffect(() => {
    if (navigationPage) {
      dispatch(landingResetState());
      navigate(navigationPage, { replace: true });
    }
  }, [navigationPage]);

  useEffect(() => {
    dispatch(landingAction());
  }, []);

  useEffect(() => {
    if (!user) {
      dispatch(getLandingContentAction());
    }
  }, [user]);

  useEffect(() => {
    if (errorMeApi) {
      dispatch(landingResetState());
    }
  }, [errorMeApi]);

  useEffect(() => {
    if (errorRooms) {
      dispatch(roomsResetState());
    }
  }, [errorRooms]);

  const scrollToServices = () => {
    if (servicesRef) {
      // @ts-ignore
      servicesRef?.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const scrollToFooter = () => {
    if (footerRef) {
      // @ts-ignore
      footerRef?.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const scrollToMap = () => {
    if (mapRef) {
      // @ts-ignore
      mapRef?.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const scrollToRooms = () => {
    if (roomsRef) {
      // @ts-ignore
      roomsRef?.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <LandingPageStyled.Container>
        <HeaderLandingPage
          scrollToServices={scrollToServices}
          scrollToFooter={scrollToFooter}
          scrollToMap={scrollToMap}
          scrollToRooms={scrollToRooms}
        />
        <LinearLoading loading={loading || loadingRooms} />
        {allDataFetched && !loading && !loadingRooms && (
          <>
            <LandingPageStyled.ContainerCarousel>
              <Carousel
                indicators={true}
                navButtonsAlwaysInvisible={true}
                stopAutoPlayOnHover={false}
                interval={6000}
                indicatorContainerProps={{
                  style: {
                    zIndex: 1,
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                  },
                }}
              >
                {itemsCarouselLandingPage.map((item: any, index: number) => (
                  <LandingPageStyled.ItemCarousel key={index} img={item.img}>
                    <LandingPageStyled.ItemCarouselText color={item.textColor}>
                      {item.description}
                    </LandingPageStyled.ItemCarouselText>
                  </LandingPageStyled.ItemCarousel>
                ))}
              </Carousel>
            </LandingPageStyled.ContainerCarousel>
            <TopHero />
            <VideoPlayer />
            <LandingPageStyled.ContainerTitlePage>
              {servicesLandingPage.length > 0 && (
                <LandingPageStyled.ContainerServices
                  ref={servicesRef}
                  container
                >
                  <LandingPageStyled.TitleServices>
                    {i18n.t('landing.ourServices')}
                  </LandingPageStyled.TitleServices>
                  <LandingPageStyled.ContainerRowService container>
                    {servicesLandingPage
                      .map((service: any, index: number) => (
                        <LandingPageStyled.ContainerServiceItem
                          item
                          md={4}
                          xs={6}
                          key={index}
                        >
                          <ServiceItem icon={service.svg} service={service} />
                        </LandingPageStyled.ContainerServiceItem>
                      ))}
                  </LandingPageStyled.ContainerRowService>
                  {/*<LandingPageStyled.ContainerButtonService>*/}
                  {/*  <Button*/}
                  {/*    onClick={() => navigate('/customer/booking')}*/}
                  {/*    label={i18n.t('landing.bookNow')}*/}
                  {/*    variant={ButtonVariant.Dark}*/}
                  {/*  />*/}
                  {/*</LandingPageStyled.ContainerButtonService>*/}
                </LandingPageStyled.ContainerServices>
              )}
              {roomsList.length > 0 && (
                <LandingPageStyled.ContainerRooms ref={roomsRef} container>
                  <LandingPageStyled.ContainerRoom item xs={12} md={9}>
                    <RoomDetail
                      variant={RoomDetailVariant.LandingPage}
                      buttonTitle={i18n.t('landing.bookNow')}
                      // onPressButton={() =>
                      //   navigate(`/customer/booking/${roomsList[0].id}`)
                      // }
                      room={roomsList[0]}
                    />
                    <RoomDetail
                      variant={RoomDetailVariant.LandingPage}
                      buttonTitle={i18n.t('landing.bookNow')}
                      // onPressButton={() =>
                      //   navigate(`/customer/booking/${roomsList[1].id}`)
                      // }
                      room={roomsList[1]}
                      imagePosition={isMobile ? 'right' : 'left'}
                    />
                  </LandingPageStyled.ContainerRoom>
                </LandingPageStyled.ContainerRooms>
              )}
            </LandingPageStyled.ContainerTitlePage>
            <MapComponent handleRefMap={mapRef => setMapRef(mapRef)} />
            <Description />
          </>
        )}
      </LandingPageStyled.Container>
      <FooterLandingPage
        handleRefFooter={footerRef => setFooterRef(footerRef)}
      />
    </>
  );
};

export default LandingPage;
